import { SVGProps } from ".";

export function MovementIcon({ color = "black", size = 18 }: SVGProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        stroke={`${color}`}
        fill="none"
        strokeWidth="0"
        viewBox="0 0 24 24"
        color={`${color}`}
        height={`${size}`}
        width={`${size}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.8 11.2V10.0071C16.8 9.56165 17.3386 9.33857 17.6536 9.65355L19.6464 11.6464C19.8417 11.8417 19.8417 12.1583 19.6464 12.3536L17.6536 14.3464C17.3386 14.6614 16.8 14.4383 16.8 13.9929V12.8H12.8V16.8H13.9929C14.4383 16.8 14.6614 17.3386 14.3464 17.6536L12.3536 19.6464C12.1583 19.8417 11.8417 19.8417 11.6464 19.6464L9.65355 17.6536C9.33857 17.3386 9.56165 16.8 10.0071 16.8H11.2V12.8H7.2V13.9929C7.2 14.4383 6.66143 14.6614 6.34645 14.3464L4.35355 12.3536C4.15829 12.1583 4.15829 11.8417 4.35355 11.6464L6.34645 9.65355C6.66143 9.33857 7.2 9.56165 7.2 10.0071V11.2H11.2V7.2H10.0071C9.56165 7.2 9.33857 6.66143 9.65355 6.34645L11.6464 4.35355C11.8417 4.15829 12.1583 4.15829 12.3536 4.35355L14.3464 6.34645C14.6614 6.66143 14.4383 7.2 13.9929 7.2H12.8V11.2H16.8Z"
          fill={`${color}`}
        />
      </svg>
    </div>
  );
}
